"use strict";
var upload_item_1 = require('./uploader/upload-item');
exports.UploadItem = upload_item_1.UploadItem;
var uploader_1 = require('./uploader/uploader');
exports.Uploader = uploader_1.Uploader;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-http-file-upload/index.js
// module id = 207
// module chunks = 10